// import { useNavigate } from "react-router-dom";

// export default function NotificationsDropdown({
//   invites = [],
//   notifications = [],
//   onAccept,
//   onDecline,
//   onClose,
// }) {
//   const navigate = useNavigate();

//   if (!invites.length && !notifications.length)
//     return (
//       <div className="relative bg-slate-900 border border-lime-400 rounded-xl shadow-xl p-4 w-72">
//         <button
//           className="absolute top-2 right-2 text-gray-400 hover:text-red-500 text-2xl"
//           onClick={onClose}
//           aria-label="Close"
//         >
//           ×
//         </button>
//         <div className="text-gray-400 text-center">No new notifications</div>
//       </div>
//     );

//   return (
//     <div className="relative bg-slate-900 border border-lime-400 rounded-xl shadow-xl p-2 w-72">
//       {/* Close button */}
//       <button
//         className="absolute top-2 right-2 text-gray-400 hover:text-red-500 text-2xl"
//         onClick={onClose}
//         aria-label="Close"
//       >
//         ×
//       </button>
//       {/* System notifications */}
//       {notifications.map((notif) => (
//         <div
//           key={notif.id}
//           className="flex items-start gap-2 mb-2 bg-slate-800 rounded-lg p-2"
//         >
//           <div>
//             <div className="font-bold text-lime-300">{notif.title}</div>
//             <div className="text-gray-200 text-xs mb-1">{notif.message}</div>
//             <div className="text-gray-400 text-[10px]">
//               {notif.timestamp?.toDate
//                 ? notif.timestamp.toDate().toLocaleString()
//                 : notif.timestamp}
//             </div>
//           </div>
//         </div>
//       ))}

//       {/* Game Invites */}
//       {invites.map((invite) => (
//         <div
//           key={invite.gameId || invite.inviteId}
//           className="flex items-center gap-2 mb-2 bg-slate-800 rounded-lg p-2"
//         >
//           <img
//             src={invite.from?.avatar || "/user.jpg"}
//             className="w-8 h-8 rounded-full"
//             alt=""
//           />
//           <div className="flex-1">
//             <div className="font-bold text-lime-400">
//               {invite.from?.username || "Unknown"}
//             </div>
//             <div className="text-gray-300 text-xs">
//               invited you to {invite.gameType} Game!
//             </div>
//           </div>
//           <button
//             className="bg-lime-500 px-2 py-1 rounded-full text-white text-xs"
//             onClick={() => {
//               let path = "/";
//               if (invite.gameType === "xo") path = "/xogame";
//               else if (invite.gameType === "rps") path = "/rps";
//               navigate(path, { state: { pendingInviteId: invite.inviteId } });
//               if (onAccept) onAccept(invite);
//               if (onClose) onClose();
//             }}
//           >
//             Accept
//           </button>
//           <button
//             className="bg-gray-700 px-2 py-1 rounded-full text-gray-300 text-xs"
//             onClick={() => {
//               let path = "/";
//               if (invite.gameType === "xo") path = "/xogame";
//               else if (invite.gameType === "rps") path = "/rps";
//               navigate(path);
//               if (onDecline) onDecline(invite);
//               if (onClose) onClose();
//             }}
//           >
//             Decline
//           </button>
//         </div>
//       ))}
//     </div>
//   );
// }

import { doc, deleteDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function NotificationsDropdown({
  invites = [],
  notifications = [],
  onAccept,
  onDecline,
  onClose,
}) {
  const [notifs, setNotifs] = useState(notifications);
  const navigate = useNavigate();

  // Remove from Firestore and from local UI
  const dismissNotif = async (notifId) => {
    try {
      // Delete from Firestore
      await deleteDoc(doc(db, "notifications", notifId));
      setNotifs((prev) => prev.filter((n) => n.id !== notifId));
    } catch (err) {
      // fallback: just hide from UI
      setNotifs((prev) => prev.filter((n) => n.id !== notifId));
    }
  };

  if (!invites.length && !notifs.length)
    return (
      <div className="relative bg-slate-900 border border-lime-400 rounded-xl shadow-xl p-4 w-72">
        <button
          className="absolute top-2 right-2 text-gray-400 hover:text-red-500 text-2xl"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <div className="text-gray-400 text-center">No new notifications</div>
      </div>
    );

  return (
    <div className="relative bg-slate-900 border border-lime-400 rounded-xl shadow-xl p-2 w-72">
      {/* Close Dropdown Button */}
      <button
        className="absolute top-2 right-2 text-gray-400 hover:text-red-500 text-2xl"
        onClick={onClose}
        aria-label="Close"
      >
        ×
      </button>
      {/* System notifications */}
      {notifs.map((notif) => (
        <div
          key={notif.id}
          className="flex flex-col gap-2 mb-2 bg-slate-800 rounded-lg p-3 border border-lime-400"
        >
          <div className="flex items-center justify-between">
            <span className="font-bold text-lime-300 text-lg">
              {notif.title}
            </span>
          </div>
          <div className="text-gray-200 text-base mb-1">{notif.message}</div>
          <div className="text-gray-400 text-xs mb-2">
            {notif.timestamp?.toDate
              ? notif.timestamp.toDate().toLocaleString("en-GB")
              : notif.timestamp}
          </div>
          <button
            className="bg-red-500 hover:bg-red-700 text-white px-3 py-1 rounded text-xs mt-1"
            onClick={() => dismissNotif(notif.id)}
          >
            Dismiss
          </button>
        </div>
      ))}

      {/* Game Invites (as before) */}
      {invites.map((invite) => (
        <div
          key={invite.gameId || invite.inviteId}
          className="flex items-center gap-2 mb-2 bg-slate-800 rounded-lg p-2"
        >
          <img
            src={invite.from?.avatar || "/user.jpg"}
            className="w-8 h-8 rounded-full"
            alt=""
          />
          <div className="flex-1">
            <div className="font-bold text-lime-400">
              {invite.from?.username || "Unknown"}
            </div>
            <div className="text-gray-300 text-xs">
              invited you to {invite.gameType} Game!
            </div>
          </div>
          <button
            className="bg-lime-500 px-2 py-1 rounded-full text-white text-xs"
            onClick={() => {
              let path = "/";
              if (invite.gameType === "xo") path = "/xogame";
              else if (invite.gameType === "rps") path = "/rps";
              navigate(path, { state: { pendingInviteId: invite.inviteId } });
              if (onAccept) onAccept(invite);
              if (onClose) onClose();
            }}
          >
            Accept
          </button>
          <button
            className="bg-gray-700 px-2 py-1 rounded-full text-gray-300 text-xs"
            onClick={() => {
              let path = "/";
              if (invite.gameType === "xo") path = "/xogame";
              else if (invite.gameType === "rps") path = "/rps";
              navigate(path);
              if (onDecline) onDecline(invite);
              if (onClose) onClose();
            }}
          >
            Decline
          </button>
        </div>
      ))}
    </div>
  );
}
